import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import useAttachmentFilter from "~/hooks/useAttachmentFilter";
import {
  setBlobFilterStates,
  setRefetch,
} from "~/Pages/Process/actions/attachmentsSlice";

const useFileDocumentFilter = ({ states }) => {
  const coreEntityType = {
    "Entity Information": "ENTITIES_PLUS",
    Shareholder: "SHAREHOLDER",
    Officers: "OFFICER",
    "Power of Attorney": "POA",
    Directors: "DIRECTOR",
  };
  const { id, service_id, process_id, type, request_type, request_id } =
    useParams();
  const {
    blobFilterStates,
    filterServices,
    disableFilter,
    refetch,
    payrollPlusTemplate,
  } = useSelector((state) => state.attachments);

  const [filterData, setFilterData] = useState({});
  const [chipdata, setChipData] = useState({});
  const location = useLocation();
  const dispatch = useDispatch();
  const removeFnRef = useRef(null);
  const {
    data,
    loading: filterLoading,
    error,
    onFilterChange,
    onFilterApply,
    onSortOrderChange,
    allData,
    onPageChange: filterPageChange,
    currentPage,
    onFilterApplyFilesAndDocs,
    onFilterApplyForProcess,
  } = useAttachmentFilter();
  const {
    selectedService,
    selectedProcess,
    selectedType,
    selectedRequestType,
    selectedRequest,
    isPayslipFolder,
    folders,
    entity_detail,
  } = states || {};

  const [processTemplates, setProcessTemplates] = useState([]);
  const [requestReasons, setRequestReasons] = useState([]);
  const handleFilterProps = () => {
    if (service_id && selectedService?.name === "Core Entity Information") {
      return {
        showCategory: true,
        showServiceLine: false,
        showYears: false,
        showEntity: false,
        serviceLine: "Entities +",
      };
    } else if (service_id && selectedService?.name === "Ad Hoc Requests") {
      if (selectedRequest) {
        return {
          showCategory: true,
          showServiceLine: false,
          showYears: false,
          showEntity: false,
          showRequestType: false,
          serviceLine: "Entities +",
        };
      } else if (selectedRequestType) {
        return {
          showCategory: true,
          showServiceLine: false,
          showYears: false,
          showEntity: false,
          showRequestType: false,
          serviceLine: "Entities +",
        };
      } else if (selectedType) {
        return {
          showCategory: true,
          showServiceLine: false,
          showYears: false,
          showEntity: false,
          showRequestType: true,
          serviceLine: "Entities +",
        };
      } else {
        return {
          showCategory: true,
          showServiceLine: false,
          showYears: true,
          showEntity: false,
          showRequestType: true,
          serviceLine: "Entities +",
        };
      }
    } else if (service_id && selectedService?.isProcess) {
      if (selectedProcess) {
        return {
          showCategory: true,
          showServiceLine: false,
          showYears: false,
          showEntity: false,
          serviceLine: selectedService?.name,
        };
      } else if (selectedType) {
        return {
          showCategory: true,
          showServiceLine: true,
          showYears: false,
          showEntity: false,
          serviceLine: selectedService?.name,
          template: selectedService?.name,
        };
      } else {
        return {
          showCategory: true,
          showServiceLine: true,
          showYears: true,
          showEntity: false,
          serviceLine: selectedService?.name,
          template: selectedService?.name,
        };
      }
    } else {
      return {
        showCategory: true,
        showServiceLine: true,
        showYears: false,
        showEntity: false,
        serviceLine: null,
      };
    }
  };

  const handleRemoveFilter = (id) => {
    if (removeFnRef.current) {
      const { value: updatedValue, grouped } = removeFnRef.current(id);
      setFilterData(updatedValue);
      handleFilterChange(grouped);
    }
  };
  const handleFilterChange = (data) => {
    let serviceLine;
    let collectedTemplateIds = [];
    if (data?.service_line) {
      serviceLine = Object.entries(data?.service_line || {}).map(
        ([key, value]) => ({
          serviceLine: key,
          template: value?.map((sub) =>
            sub.includes("/") ? sub.split("/").pop() : sub,
          ),
        }),
      );
      serviceLine?.map((temp) => {
        if (temp?.template?.length) {
          if (
            temp.template?.length === 1 &&
            temp.template[0] === "PAYROLL_PAYSLIP"
          ) {
            collectedTemplateIds = [
              ...collectedTemplateIds,
              ...payrollPlusTemplate,
            ];
          } else {
            collectedTemplateIds = [...collectedTemplateIds, ...temp.template];
          }
        } else {
          const templateda = filterServices
            ?.find((f) => f.id === temp.serviceLine)
            ?.suboptions?.map((p) => p.id);

          collectedTemplateIds = [...collectedTemplateIds, ...templateda];
        }
      });
    }
    if (data?.request_type) {
      setRequestReasons(data?.request_type);
    }
    setProcessTemplates(collectedTemplateIds);

    const categories = Object.entries(data?.category || {}).map(
      ([key, value]) => ({
        category: key,
        subCategories: value?.map((sub) =>
          sub.includes("/") ? sub.split("/").pop() : sub,
        ),
      }),
    );
    setChipData(categories);
    if (service_id && selectedService?.name === "Core Entity Information") {
      if (type && selectedType?.name) {
        if (process_id) {
          onFilterChange({
            categories,
            typeId: selectedProcess?.id,
            type: selectedProcess?.type,
          });
        } else {
          onFilterChange({
            categories,
            typeId: id,
            type: coreEntityType[selectedType?.name],
          });
        }
      } else {
        onFilterChange({
          categories,
        });
      }
    } else if (service_id && selectedService?.name === "Ad Hoc Requests") {
      if (selectedRequest) {
        onFilterChange({
          categories,
          typeId: request_id,
          type: "AD_HOC",
        });
      } else if (selectedRequestType || selectedType) {
        onFilterChange({
          categories,
          typeId: id,
        });
      } else {
        onFilterChange({
          categories,
          typeId: id,
          year: data?.year?.length ? data.year : null,
        });
      }
    } else if (service_id && selectedService?.isProcess) {
      if (selectedProcess) {
        onFilterChange({
          categories,
          typeId: selectedProcess?.id,
          // type: "PROCESS",
        });
      } else if (selectedType) {
        onFilterChange({
          categories,
          // typeId: id,
          year: selectedType?.name,
        });
      } else {
        onFilterChange({
          categories,
          // typeId: id,
          year: data?.year?.length ? data.year : null,
        });
      }
    } else {
      onFilterChange({
        categories,
      });
    }
  };

  const selectedItems = Object.values(filterData || {}).filter(
    (value) =>
      !["category", "service_line", "entities", "year"].includes(value?.id),
  );

  useEffect(() => {
    dispatch(setBlobFilterStates({ ...blobFilterStates, selectedItems }));
  }, [filterData]);
  useEffect(() => {
    dispatch(
      setBlobFilterStates({
        ...blobFilterStates,
        filterLoading,
        data,
        allData,
      }),
    );
  }, [filterLoading, data, allData]);
  const fetchFilteredFiles = () => {
    if (service_id && selectedService?.name === "Core Entity Information") {
      if (type && selectedType?.name) {
        if (process_id) {
          onFilterApply();
        } else {
          onFilterApplyFilesAndDocs([coreEntityType[selectedType?.name]], id);
        }
      } else {
        onFilterApplyFilesAndDocs(
          ["ENTITIES_PLUS", "OFFICER", "SHAREHOLDER", "POA", "DIRECTOR"],
          id,
        );
      }
    } else if (service_id && selectedService?.name === "Ad Hoc Requests") {
      if (selectedRequest) {
        onFilterApply();
      } else if (selectedRequestType) {
        onFilterApplyFilesAndDocs(["AD_HOC"], id, [], entity_detail?.name, [
          selectedRequestType?.id,
        ]);
      } else {
        onFilterApplyFilesAndDocs(
          ["AD_HOC"],
          id,
          [],
          entity_detail?.name,
          requestReasons,
        );
      }
    } else if (service_id && selectedService?.isProcess) {
      if (selectedProcess) {
        onFilterApplyForProcess(["PROCESS", "PAYSLIPS"]);
      } else if (selectedType) {
        onFilterApplyFilesAndDocs(
          ["PROCESS"],
          id,
          processTemplates,
          entity_detail?.name,
        );
      } else {
        onFilterApplyFilesAndDocs(
          ["PROCESS"],
          id,
          processTemplates,
          entity_detail?.name,
          [],
          service_id,
        );
      }
    } else {
      onFilterApplyFilesAndDocs(
        [
          "ENTITIES_PLUS",
          "OFFICER",
          "PROCESS",
          "SHAREHOLDER",
          "POA",
          "DIRECTOR",
          "AD_HOC",
        ],
        id,
        processTemplates,
        entity_detail?.name,
      );
    }
    dispatch(setRefetch(false));
  };
  useEffect(() => {
    if (selectedItems?.length) {
      fetchFilteredFiles();
    }
  }, [filterData]);
  useEffect(() => {
    if (refetch) {
      fetchFilteredFiles();
    }
  }, [refetch]);
  const clearAllFilters = () => {
    if (removeFnRef.current) {
      removeFnRef.current("ALL_CLEAR");
    }
    setFilterData({});
  };

  useEffect(() => {
    clearAllFilters();
    dispatch(setRefetch(false));
  }, [location.pathname]);

  return {
    handleFilterProps,
    handleRemoveFilter,
    filterData,
    setFilterData,
    removeFnRef,
    handleFilterChange,
    selectedItems,
    disableFilter,
  };
};

export default useFileDocumentFilter;
